<template>
  <div class="date-picker-root" :style="getRootStyle">
    <div class="form-label label-text" v-if="label">
      {{ $t(label) }}
      <span v-if="is_required" class="req-sign">*</span>
    </div>
    <validation-provider :name="name" :rules="rules" v-slot="{ errors }">
      <input type="text" v-model="inputfield" class="d-none" />
      <!-- flex-wrap -->
      <div class="d-flex align-items-center" :id="id">
        <div style="margin-right: 0.5rem">
          <div
            class="form-control time-input disabled"
            :style="cus_style"
            v-if="disabled || readOnly"
          >
            <div class="block">
              <span id="time-picker_hrs" v-if="hr">{{
                hr.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })
              }}</span>
              <span v-else>00</span>
            </div>
            <div class="seprator">:</div>
            <div class="block">
              <span id="time-picker_min" v-if="min">{{
                min.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })
              }}</span>
              <span v-else>00</span>
            </div>
          </div>
          <div
            v-else
            :class="[
              'form-control',
              'time-input',
              {
                'invalid-time-input':
                  is_invalid || (errors && errors.length) ? true : false,
              },
              {
                'disabled-time-input': disabled ? true : false,
              },
              {
                'd-flex flex-row-reverse': isLangRtl,
              },
            ]"
            @click.stop="openSelector"
          >
            <div class="block">
              <input
                type="text"
                id="time-picker_hrs"
                ref="time-picker_hrs"
                style="width: 21px; border: none"
                v-model="hr"
                @keydown="keydownhr"
              />
              <!-- <span id="time-picker_hrs" v-if="hr">{{
                hr.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })
              }}</span>
              <span v-else>00</span> -->
            </div>
            <div class="seprator">:</div>
            <div class="block">
              <input
                type="text"
                id="time-picker_min"
                ref="time-picker_min"
                style="width: 21px; border: none"
                v-model="min"
                @keydown="keydownmin"
              />
              <!-- <span id="time-picker_min" v-if="min">{{
                min.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })
              }}</span>
              <span v-else>00</span> -->
            </div>
          </div>
          <div
            v-if="open_selector"
            v-click-outside="openSelector"
            :class="[
              'd-flex',
              'align-items-center',
              'selector-block',
              {
                'flex-row-reverse': isLangRtl,
              },
            ]"
          >
            <div
              id="time-picker-available_hrs"
              class="time-seletor"
              ref="hrScrollContainer"
            >
              <div
                ref="hr_options"
                v-for="v_hr in available_hrs"
                :key="v_hr"
                :class="[
                  'block',
                  {
                    active:
                      v_hr.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }) ===
                      hr.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }),
                  },
                ]"
                @click.stop="
                  setHr(
                    v_hr.toLocaleString('en-US', {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })
                  )
                "
              >
                {{
                  v_hr.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                  })
                }}
              </div>
            </div>
            <div
              id="time-picker-available_mins"
              class="time-seletor"
              ref="minScrollContainer"
            >
              <div
                ref="min_options"
                v-for="v_min in available_mins"
                :key="v_min"
                :class="[
                  'block',
                  {
                    active:
                      (v_min - 1).toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }) ===
                      min.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }),
                  },
                ]"
                @click.stop="
                  setMin(
                    (v_min - 1).toLocaleString('en-US', {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })
                  )
                "
              >
                {{
                  (v_min - 1).toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                  })
                }}
              </div>
            </div>
          </div>
        </div>
  <div v-if="!use24Hour && dropdown_meridiem_picker">
          <base-select
            id="time-picker-meridiem"
            :options="[
              {
                text: $t('am'),
                value: 'AM',
              },
              {
                text: $t('pm'),
                value: 'PM',
              },
            ]"
            field="meridiem"
            :value="meridiem"
            @change-value="setValue"
            :remove_default_margin="true"
            cus_style="color:var(--color-17);"
            :disabled="disabled ? true : false"
          ></base-select>
        </div>
        <div v-else-if="!use24Hour" class="d-flex align-items-center">
          <div style="margin-right: 0.5rem">
            <div
              :class="[
                'meridiem-input',
                'form-control',
                'd-flex',
                'justify-content-center',
                'align-items-center',
                { selected: meridiem === 'AM' ? true : false },
                {
                  'disabled-meridiem-input': disabled ? true : false,
                },
              ]"
              @click.stop="selectMeridiem('AM')"
            >
              {{ $t("am") }}
            </div>
          </div>
          <div style="margin-right: 0.5rem">
            <div
              :class="[
                'meridiem-input',
                'form-control',
                'd-flex',
                'justify-content-center',
                'align-items-center',
                { selected: meridiem === 'PM' ? true : false },
                {
                  'disabled-meridiem-input': disabled ? true : false,
                },
              ]"
              @click.stop="selectMeridiem('PM')"
            >
              {{ $t("pm") }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="helper_text" class="helper-text" :style="helper_text_style">
        {{ $t(helper_text) }}
      </div>
      <div
        class="error-text"
        :style="helper_text_style"
        v-if="errors && errors.length"
      >
        {{ errors[0] }}
      </div>
      <slot name="attachment"></slot>
    </validation-provider>
  </div>
</template>

<script>
export default {
  emits: ["change-value", "change"],
  props: [
    "id",
    "label",
    "placeholder",
    "is_invalid",
    "helper_text",
    "helper_text_style",
    "field",
    "value",
    "cus_style",
    "remove_default_margin",
    "readOnly",
    "disabled",
    "cus_ref",
    "is_required",
    "options",
    "rules",
    "name",
    "dropdown_meridiem_picker",
    "use24Hour",
  ],
  data() {
    return {
      hr: "00",
      min: "00",
      // available_hrs is an array of hour values. For 24-hour mode use 0..23, otherwise 1..12
      available_hrs: this.use24Hour
        ? Array.from({ length: 24 }, (_, i) => i)
        : Array.from({ length: 12 }, (_, i) => i + 1),
      available_mins: 60,
      meridiem: "AM",
      open_selector: false,
      inputfield: this.value,
      arrowHrCounter: -1,
      arrowMinCounter: 0,
    };
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${
        this.remove_default_margin ? "0px" : "20px"
      };position:relative;`;
    },
  },
  methods: {
    keydownhr(e) {
      if (e.keyCode === 39) {
        this.$refs["time-picker_min"].focus();
      } else if (
        e.keyCode === 38 &&
        Number(this.hr) < (this.use24Hour ? 23 : 12)
      ) {
        this.setHr(
          (Number(this.hr) + 1).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        );
        if (this.arrowHrCounter < this.available_hrs.length - 1) {
          this.arrowHrCounter = this.arrowHrCounter + 1;
          if (this.open_selector) this.fixHrScrolling();
        }
        } else if (e.keyCode === 40 && Number(this.hr) > (this.use24Hour ? 0 : 1)) {
        this.setHr(
          (Number(this.hr) - 1).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        );

        if (this.arrowHrCounter > 0) {
          this.arrowHrCounter = this.arrowHrCounter - 1;
          if (this.open_selector) this.fixHrScrolling();
        }
      } else e.preventDefault();
    },
    fixHrScrolling() {
      const liH = this.$refs.hr_options[this.arrowHrCounter].clientHeight;
      this.$refs.hrScrollContainer.scrollTop = liH * this.arrowHrCounter;
    },
    keydownmin(e) {
      if (e.keyCode === 37) {
        this.$refs["time-picker_hrs"].focus();
      } else if (
        e.keyCode === 38 &&
        Number(this.min) < Number(this.available_mins - 1)
      ) {
        this.setMin(
          (Number(this.min) + 1).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        );
        if (this.arrowMinCounter < this.available_mins - 1) {
          this.arrowMinCounter = this.arrowMinCounter + 1;
          if (this.open_selector) this.fixMinScrolling();
        }
      } else if (e.keyCode === 40 && Number(this.min) >= 1) {
        this.setMin(
          (Number(this.min) - 1).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        );
        if (this.arrowMinCounter > 0) {
          this.arrowMinCounter = this.arrowMinCounter - 1;
          if (this.open_selector) this.fixMinScrolling();
        }
      } else e.preventDefault();
    },
    fixMinScrolling() {
      const liH = this.$refs.min_options[this.arrowMinCounter].clientHeight;
      this.$refs.minScrollContainer.scrollTop = liH * this.arrowMinCounter;
    },
    setValue(val, field) {
      this[field] = val;
    },
    selectMeridiem(meridiem) {
      if (!this.disabled && this.hr !== "00") this.meridiem = meridiem;
    },
    setHr(hr) {
      this.hr = hr;
    },
    setMin(min) {
      this.min = min;
    },
    openSelector() {
      if (!this.disabled) this.open_selector = !this.open_selector;
    },
    setVal() {
      let hr = this.hr;
      if (this.use24Hour) {
        // in 24-hour mode the hr is stored as 00..23 already
        this.inputfield = `${String(hr).padStart(2, '0')}:${String(this.min).padStart(2, '0')}:00`;
      } else {
        if (hr != 12 && this.meridiem === "PM") {
          this.inputfield = `${parseInt(hr, 10) + 12}:${this.min}:00`;
        } else if (hr == 12 && this.meridiem === "AM") {
          this.inputfield = `00:${this.min}:00`;
        } else {
          this.inputfield = `${hr < 10 ? `${hr}` : hr}:${this.min}:00`;
        }
      }
    },
    getVal() {
      if (this.value && this.value.length > 1) {
        let parts = this.value.split(":");
        if (parts.length) {
          this.hr = parts[0];
          this.min = parts[1];
          if (this.use24Hour) {
            // keep hr as 00..23 and don't infer meridiem
            this.meridiem = "AM";
          } else {
            if (parseInt(this.hr, 0) >= 12) {
              this.meridiem = "PM";
              if (parseInt(this.hr, 0) > 12) {
                this.hr = parseInt(this.hr, 0) - 12;
              }
            } else if (parseInt(this.hr, 0) === 0) {
              this.meridiem = "AM";
              this.hr = 12;
            } else {
              this.hr = parseInt(this.hr, 0);
              this.meridiem = "AM";
            }
          }
        }
      } else {
        this.hr = "00";
        this.min = "00";
        this.meridiem = "AM";
      }
      this.hr = this.hr.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      this.min = this.min.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    },
  },
  watch: {
    inputfield(val) {
      this.$emit("change-value", val, this.field);
      this.$emit("change", val);
    },
    value() {
      this.getVal();
    },
    hr() {
      this.setVal();
    },
    min() {
      this.setVal();
    },
    meridiem() {
      this.setVal();
    },
  },
  mounted() {
    this.getVal();
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 14px;
  color: var(--color-61);
  margin-bottom: 5px;
  font-weight: 700;
}

.time-input {
  display: flex;
  align-items: center;
  color: var(--color-17) !important;
  position: relative;
  .block {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: var(--color-17);
  }

  .seprator {
    margin: 0rem 0.25rem;
  }
}

.invalid-time-input {
  border-color: var(--color-47) !important;
}

.disabled-time-input {
  background-color: var(--color-10) !important;
}
.selector-block {
  position: absolute;
  background-color: var(--color-01);
  border: 1px solid var(--color-04);
  z-index: 1000;
  top: 110%;
  .time-seletor {
    max-height: 120px;
    overflow: auto;
    scrollbar-width: none;

    .block {
      cursor: pointer;
      width: 32px;
      padding: 0.25rem;
      text-align: center;
      font-size: 14px;
      color: var(--color-17);
      &:hover {
        background: var(--color-09);
        color: var(--color-01);
      }
    }
    .active {
      background: var(--color-09);
      color: var(--color-01);
    }
  }
  .time-seletor::-webkit-scrollbar {
    width: 0px;
  }
}
.meridiem-input {
  font-size: 16px;
  color: var(--color-04) !important;
  border-color: var(--color-04) !important;
  cursor: pointer;
  width: 38px !important;
}

.disabled-meridiem-input {
  background-color: var(--color-10) !important;
}

.meridiem-input.selected {
  color: var(--color-17) !important;
  border-color: var(--color-03) !important;
}
.form-control {
  width: 100%;
  height: 40px;
  font-size: 14px;
  padding: 10px;
  background: var(--color-01);
  color: var(--color-61);
  border: 1px solid;
  border-radius: 6px;
  border-color: var(--color-64);
  box-shadow: 0px 1px 2px var(--color-37);
  font-weight: 400;

  &:focus-visible {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:hover {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:focus {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:disabled {
    background-color: var(--color-67);
  }
}

input {
  &:focus-visible {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:hover {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:focus {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:disabled {
    background-color: var(--color-67);
  }
}
</style>

